import Container from "react-bootstrap/esm/Container";
import description from '../Assets/img/Collaboration.png';
import stonks from '../Assets/img/augmentationRevenus.png';
import schema from '../Assets/img/schemaTransformation.png';
import {Link} from "react-router-dom";
import '../Assets/css/Accueil.css'

function Accueil() {
  return (
    <>
      <header className="header-section text-white d-flex align-items-center justify-content-center">
        <Container>
          <h1 className="display-4 fw-bold">Élargissez votre clientèle grâce à une présence en ligne efficace.</h1>
          <p className="lead">Plus de visibilité, plus d’engagement, plus de ventes.</p>
        </Container>
      </header>
      <div className="container-fluid split-section py-5">
        <div className="row align-items-center">
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              src={description}
              alt="Collaboration avec les clients"
              className="split-image"
            />
          </div>
          <div className="col-md-6 text-side p-5 text-center p-4">
            <h1 className="fw-bold">Un service vraiment adapté à vous</h1>
            <p className="lead fw-medium">Nous prenons le temps d’échanger avec chaque client afin de trouver l’abonnement qui correspond parfaitement à son budget, ses besoins et ses objectifs. Votre réussite est notre priorité.</p>
            {/* <button className="btn btn-dark">Contactez-Nous</button> */}
            <Link to="/Contact" className="btn btn-dark">Contactez-Nous</Link>
          </div>
        </div>
      </div>
      <div className="container-fluid split-section py-5">
        <div className="row align-items-center">
          <div className="col-md-6 text-side p-5 text-center p-4">
            <h1 className="fw-bold">Convertissez vos abonnés en revenus concrets</h1>
            <p className="lead fw-medium">Les réseaux sociaux sont votre meilleur levier pour transformer chaque abonné en client. Boostez votre visibilité et vos ventes dès maintenant !</p>
          </div>
          <div className="col-md-6 order-first order-md-last d-flex justify-content-center align-items-center">
            <img
              src={stonks}
              alt="Augmentez vos revenus"
              className="split-image"
            />
          </div>
        </div>
      </div>
      <div className="p-5 text-center">
        <p className="lead fw-medium">Notre objectif est simple, vous faire gagner du temps sur la gestion de vos publicités tout en maximisant vos résultats.
                            Grâce à une stratégie adaptée, nous transformons chaque vue en opportunité réelle. Notre équipe, engagée et déterminée, met tout en œuvre pour améliorer
                            vos conversions et vos ventes.
        </p>
        <img
          src={schema}
          alt="Transformez vos vus en revenus"
          className="flow-image"
        />
      </div>
    </>
  );
}

export default Accueil;